function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "icon_map_point");

var _ref3 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("path", {
  d: "M187.64,0C84.18,0,0,84.18,0,187.64c0,47.54,30,114.69,89,199.61a1342.6,1342.6,0,0,0,87.43,112.13L187.64,512l11.2-12.62a1342.6,1342.6,0,0,0,87.43-112.13c59.07-84.92,89-152.07,89-199.61C375.29,84.18,291.11,0,187.64,0Zm74.22,369.91c-29.18,42-58.68,78.12-74.22,96.55-15.5-18.38-44.88-54.37-74-96.3C58.91,291.48,30,228.36,30,187.64c0-87,70.75-157.71,157.71-157.71s157.72,70.75,157.72,157.71C345.36,228.32,316.48,291.35,261.86,369.91Z",
  fill: "#fff"
}), React.createElement("path", {
  d: "M187.64,69.35A110.75,110.75,0,1,0,298.39,180.1,110.74,110.74,0,0,0,187.64,69.35Zm0,191.56a80.81,80.81,0,1,1,80.82-80.81A80.81,80.81,0,0,1,187.64,260.91Z",
  fill: "#fff"
}));

var SvgIconMapPoint = function SvgIconMapPoint(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 375.27,
    height: 512,
    viewBox: "0 0 375.27 512",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconMapPoint, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_map_point.b5b95c28.svg";
export { ForwardRef as ReactComponent };